"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostProductRemove = void 0;
const Base_1 = require("./Base");
exports.PostProductRemove = {
    url: Base_1.URL_BASE + "/ProductRemove",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostProductRemove.js.map